/**
 * Two-line label for an Apple-backed /api/address/search result: the venue,
 * hotel or place name first, then street / town on a muted second line.
 * Never invents data — when the DTO carries no separate street/city we split
 * the provider's own display string at its first comma.
 */
export interface AddressSuggestionParts {
  display_name: string;
  street?: string | null;
  city?: string | null;
  state?: string | null;
}

export function addressSuggestionLines(s: AddressSuggestionParts): { primary: string; secondary: string } {
  const name = s.display_name.trim();
  const locality = [s.street, s.city, s.state]
    .map((v) => (typeof v === "string" ? v.trim() : ""))
    .filter((v) => v && !name.toLowerCase().startsWith(v.toLowerCase()));
  if (locality.length > 0) {
    const firstSegment = name.split(",")[0].trim();
    return { primary: firstSegment || name, secondary: locality.join(", ") };
  }
  const comma = name.indexOf(",");
  if (comma > 0) return { primary: name.slice(0, comma).trim(), secondary: name.slice(comma + 1).trim() };
  return { primary: name, secondary: "" };
}

export function optionalString(v: unknown): string | undefined {
  return typeof v === "string" && v.trim() ? v : undefined;
}
